<h1 mat-dialog-title>{{initialized ? data.title : "Loading..."}}</h1>
<div mat-dialog-content>
  @if (!initialized) {
    <mat-progress-bar mode="buffer"></mat-progress-bar>
  }
  @if (initialized) {
    <div class="text-end">
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Individual name</mat-label>
          <input matInput type="text" placeholder="Start typing.."
            [formControl]="individualNameFilterControl" />
            <mat-icon matPrefix>search</mat-icon>
          </mat-form-field>
        </p>
      </div>
      <mat-paginator [length]="totalNumberOfIndividuals" [pageIndex]="page-1" [pageSize]="limit"
        [pageSizeOptions]="[10, 15, 20]" showFirstLastButtons (page)="onPageChange($event)"
        aria-label="Select page of individuals">
      </mat-paginator>
      <div class="py-2">
        <mat-divider></mat-divider>
      </div>
      <table mat-table [dataSource]="individualsDataSource" class="individual-list">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef> Title </th>
          <td mat-cell *matCellDef="let selectable"> {{selectable.individual.title}} </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let selectable"> {{ selectable.individual.first_name + " " +
            selectable.individual.last_name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> Type </th>
          <td mat-cell *matCellDef="let selectable"> {{ getIndividualType(selectable.individual) }} </td>
        </ng-container>
        <ng-container matColumnDef="contact">
          <th mat-header-cell *matHeaderCellDef> Contact </th>
          <td mat-cell *matCellDef="let selectable"> {{ selectable.individual.phone_number }} </td>
        </ng-container>
        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created
          </th>
          <td mat-cell *matCellDef="let selectable"> {{getCreationTime(selectable.individual)}}</td>
        </ng-container>
        <ng-container matColumnDef="selected">
          <th mat-header-cell *matHeaderCellDef>
            Selected
          </th>
          <td mat-cell *matCellDef="let selectable">
            <mat-checkbox [disableRipple]="true" (click)="$event.preventDefault()" color="primary"
            [checked]="selectable.selected"></mat-checkbox>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row [class.selected]="row.selected" (click)="selectIndividual(row)"
        *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    }
  </div>
  <div mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="null">Cancel</button>
    <button mat-raised-button [disabled]="!selectedIndividual || isLoading" [mat-dialog-close]="selectedIndividual"
    color="primary" cdkFocusInitial>Apply</button>
  </div>